/**
 * ```ts
 *  0: 'todos los ámbitos',
 *  1: 'españa',
 *  2: 'portugal',
 *  3: 'andorra',
 *  4: 'colombia',
 *  5: 'senegal',
 *  6: 'méjico',
 *  7: 'guatemala',
 *  8: 'chile',
 *  9: 'bonaire'
 * ```
 */
export enum TipoAmbitos {
  todos = 0,
  espana = 1,
  portugal = 2,
  andorra = 3,
  colombia = 4,
  senegal = 5,
  mexico = 6,
  guatemala = 7,
  chile = 8,
  bonaire = 9
}
export type TipoKeyAmbitos = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
export type TipoGrupos =
  | 'MO'
  | 'OPTC'
  | 'AA'
  | 'FLO'
  | 'MIOPT'
  | 'CLR'
  | 'CECOP'
  | 'CIONE'
  | 'FEDER'
  | 'FARMA'
  | 'OPTM'
  | 'AIOO'
  | 'KIMER'
  | 'VISTA'
  | 'SERVI'
  | 'INDEP'
  | 'PORT'
  | 'VISTF'
  | 'UGO'
  | 'VISTL'
  | 'CECOC'
  | 'OPTCMX';

type TiposGruposNombre =
  | 'multiopticas'
  | 'opticalia'
  | 'alain afflelou'
  | 'florida'
  | 'mioptico'
  | 'claravision'
  | 'cecop'
  | 'cione'
  | 'federopticos'
  | 'farmaoptics'
  | 'optimil'
  | 'aioogroup'
  | 'kimervision'
  | 'vistaoptica'
  | 'serviopticas'
  | 'independiente'
  | 'portugal'
  | 'vistaoptica franquicias'
  | 'ugo'
  | 'vistalia'
  | 'cecop colombia'
  | 'opticalia mejico';
export const TipoGrupos: Readonly<{ [key in TiposGruposNombre]: TipoGrupos }> = {
  multiopticas: 'MO',
  opticalia: 'OPTC',
  'alain afflelou': 'AA',
  florida: 'FLO',
  mioptico: 'MIOPT',
  claravision: 'CLR',
  cecop: 'CECOP',
  cione: 'CIONE',
  federopticos: 'FEDER',
  farmaoptics: 'FARMA',
  optimil: 'OPTM',
  aioogroup: 'AIOO',
  kimervision: 'KIMER',
  vistaoptica: 'VISTA',
  serviopticas: 'SERVI',
  independiente: 'INDEP',
  portugal: 'PORT',
  'vistaoptica franquicias': 'VISTF',
  ugo: 'UGO',
  vistalia: 'VISTL',
  'cecop colombia': 'CECOC',
  'opticalia mejico': 'OPTCMX'
};
export type DatosTokenRoles = 'ROLE_USUARIO' | 'ROLE_DEIPE-ADMIN' | 'ROLE_DEIPE-SOPORTE';
export interface DatosToken {
  ambito: TipoAmbitos;
  cdggrupocadena: TipoGrupos;
  roles: DatosTokenRoles[];
}
export interface InformacionEmpresa {
  empresa_id: number;
  nombre: string;
}

export type TipoPermiso =
'permitir_crear_sociedades' |
'permitir_crear_sucursales' |
'consulta_datos_compartidos_tiendas';

export type ValorPermiso = 'N' | 'T' | 'S';

export type PermisosPermiso = {[key in TipoPermiso]?: ValorPermiso};
export interface Permisos {
  configuracion: {[key: string]: ValorPermiso};
  empresa: {[key: string]: ValorPermiso};
  expregular: {[key: string]: string};
  maximo: {[key: string]: string};
  obligatorio: {[key: string]: ValorPermiso};
  permiso: PermisosPermiso;
}
